// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangePasswordForm_container__Guwrf {
  max-width: 620px;
  padding: var(--space-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--bg);
  box-shadow: var(--shadow-xs);
  box-sizing: border-box;
}

.ChangePasswordForm_title__ArtuO {
  margin: 0 0 var(--space-5);
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: -0.008em;
  color: var(--text-primary);
}

.ChangePasswordForm_form__RiYXT {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.ChangePasswordForm_field__VzZYI {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}

.ChangePasswordForm_label__r7Spm {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
  color: var(--text-primary);
}

.ChangePasswordForm_input__ExM-1 {
  width: 100%;
  min-height: 40px;
  padding: 9px 12px;
  border: 1px solid var(--border-dark);
  border-radius: var(--radius-input);
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  line-height: 1.45;
  box-sizing: border-box;
  transition:
    border-color var(--dur-fast) var(--ease-standard),
    box-shadow var(--dur-fast) var(--ease-standard);
}

.ChangePasswordForm_input__ExM-1::placeholder {
  color: var(--text-placeholder);
}

.ChangePasswordForm_input__ExM-1:focus,
.ChangePasswordForm_input__ExM-1:focus-visible {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);
}

.ChangePasswordForm_button__4n6wH {
  align-self: flex-start;
  min-height: 40px;
  padding: 9px 18px;
  border: 1px solid transparent;
  border-radius: var(--radius-input);
  background: var(--primary);
  color: var(--text-on-primary);
  font-family: var(--font);
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.4;
  cursor: pointer;
  transition: background-color var(--dur-fast) var(--ease-standard);
}

.ChangePasswordForm_button__4n6wH:not(:disabled):hover {
  background: var(--primary-light);
}

.ChangePasswordForm_button__4n6wH:not(:disabled):active {
  transform: translateY(1px);
}

.ChangePasswordForm_button__4n6wH:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ChangePasswordForm_messageError__MMBB-,
.ChangePasswordForm_messageSuccess__1QOO4 {
  margin: 0;
  padding: 9px 12px;
  border-radius: var(--radius-sm);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.45;
}

.ChangePasswordForm_messageError__MMBB- {
  background: var(--surface-error);
  color: #b71c1c;
}

.ChangePasswordForm_messageSuccess__1QOO4 {
  background: var(--surface-success);
  color: #1b5e20;
}

@media (max-width: 600px) {
  .ChangePasswordForm_container__Guwrf {
    padding: var(--space-5);
  }

  .ChangePasswordForm_button__4n6wH {
    align-self: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Password/ChangePasswordForm.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB;;mDAEiD;AACnD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iEAAiE;AACnE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".container {\n  max-width: 620px;\n  padding: var(--space-6);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--bg);\n  box-shadow: var(--shadow-xs);\n  box-sizing: border-box;\n}\n\n.title {\n  margin: 0 0 var(--space-5);\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.4;\n  letter-spacing: -0.008em;\n  color: var(--text-primary);\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n}\n\n.label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n  color: var(--text-primary);\n}\n\n.input {\n  width: 100%;\n  min-height: 40px;\n  padding: 9px 12px;\n  border: 1px solid var(--border-dark);\n  border-radius: var(--radius-input);\n  background: var(--bg);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  line-height: 1.45;\n  box-sizing: border-box;\n  transition:\n    border-color var(--dur-fast) var(--ease-standard),\n    box-shadow var(--dur-fast) var(--ease-standard);\n}\n\n.input::placeholder {\n  color: var(--text-placeholder);\n}\n\n.input:focus,\n.input:focus-visible {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(157, 31, 95, 0.12);\n}\n\n.button {\n  align-self: flex-start;\n  min-height: 40px;\n  padding: 9px 18px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-input);\n  background: var(--primary);\n  color: var(--text-on-primary);\n  font-family: var(--font);\n  font-size: 0.9375rem;\n  font-weight: 700;\n  line-height: 1.4;\n  cursor: pointer;\n  transition: background-color var(--dur-fast) var(--ease-standard);\n}\n\n.button:not(:disabled):hover {\n  background: var(--primary-light);\n}\n\n.button:not(:disabled):active {\n  transform: translateY(1px);\n}\n\n.button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.messageError,\n.messageSuccess {\n  margin: 0;\n  padding: 9px 12px;\n  border-radius: var(--radius-sm);\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.45;\n}\n\n.messageError {\n  background: var(--surface-error);\n  color: #b71c1c;\n}\n\n.messageSuccess {\n  background: var(--surface-success);\n  color: #1b5e20;\n}\n\n@media (max-width: 600px) {\n  .container {\n    padding: var(--space-5);\n  }\n\n  .button {\n    align-self: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChangePasswordForm_container__Guwrf`,
	"title": `ChangePasswordForm_title__ArtuO`,
	"form": `ChangePasswordForm_form__RiYXT`,
	"field": `ChangePasswordForm_field__VzZYI`,
	"label": `ChangePasswordForm_label__r7Spm`,
	"input": `ChangePasswordForm_input__ExM-1`,
	"button": `ChangePasswordForm_button__4n6wH`,
	"messageError": `ChangePasswordForm_messageError__MMBB-`,
	"messageSuccess": `ChangePasswordForm_messageSuccess__1QOO4`
};
export default ___CSS_LOADER_EXPORT___;
